import React, { useState, useEffect, useRef, useMemo } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import * as XLSX from 'xlsx'
import Papa from 'papaparse'
import uploadExcelToAzure from '../utils/uploadExcelToAzure'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useNavigate } from 'react-router-dom'
import { Button, Modal } from 'antd';
import { IoClose, IoLogOut } from "react-icons/io5";
import { removeFcmToken } from '../utils/removeFcmToken'

function Inward() {
    const [staffData, setStaffData] = useState([])
    const [inwardData, setInwardData] = useState([])
    const [selectedStaff, setSelectedStaff] = useState({})
    const [excelMasterData, setExcelMasterData] = useState([])
    const fileInputRef = useRef(null)
    const [isLoading, setIsLoading] = useState(false)
    const [initialLoading, setInitialLoading] = useState(true)
    const gridRef = useRef(null)
    const gridApi = useRef(null)
    const [selectedRows, setSelectedRows] = useState([])

    const gridStyle = useMemo(() => ({
        height: window.innerWidth >= 972 ? window.innerHeight * 0.886 : window.innerWidth >= 400 ? window.innerHeight * 0.76 : window.innerHeight * 0.78,
        width: '100%',
        marginTop: window.innerWidth <= 500 && '30px'
    }), []);

    const formatDateTime = (params) => {
        if (!params?.value) return '';
        try {
            const date = new Date(params.value);
            if (isNaN(date.getTime())) return params.value; // Return original if invalid date

            const istDate = new Date(date.getTime());

            const day = String(istDate.getUTCDate()).padStart(2, '0');
            const month = String(istDate.getUTCMonth() + 1).padStart(2, '0');
            const year = istDate.getUTCFullYear().toString().slice(-2);
            const hours = String(istDate.getUTCHours()).padStart(2, '0');
            const minutes = String(istDate.getUTCMinutes()).padStart(2, '0');

            return `${day}/${month}/${year} ${hours}:${minutes}`;
        } catch (error) {
            return params.value; // Return original value if formatting fails
        }
    };

    const fetchStaffData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/receiveStaffDropdown`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    USERNAME: localStorage.getItem('USERNAME'),
                    PASSWORD: localStorage.getItem('PASSWORD')
                })
            })
            const data = await response.json()
            setStaffData(data.data)
        }
        catch (error) {
            console.error('Error fetching staff data:', error)
            toast.error('Error fetching staff data', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
        }
    }
    const fetchInwardData = async () => {
        try {
            setInitialLoading(true)
            if (gridApi.current) {
                gridApi.current.showLoadingOverlay()
            }
            const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/receiveInwardData`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    USERNAME: localStorage.getItem('USERNAME'),
                    PASSWORD: localStorage.getItem('PASSWORD')
                })
            })
            const data = await response.json()
            setInwardData(data.data)
        }
        catch (error) {
            console.error('Error fetching inward data:', error)
            toast.error('Error fetching inward data', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
        } finally {
            setInitialLoading(false)
            if (gridApi.current) {
                gridApi.current.hideOverlay()
            }
        }
    }
    const fetchExcelMasterData = async () => {
        try {

            const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/getExcelMasterData`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    USERNAME: localStorage.getItem('USERNAME'),
                    PASSWORD: localStorage.getItem('PASSWORD')
                })
            })
            const data = await response.json()
            setExcelMasterData(data.data)
        } catch (error) {
            console.error('Error fetching Excel master data:', error)
            toast.error('Error fetching Excel master data', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
        }
    }

    useEffect(() => {
        fetchStaffData()
        fetchExcelMasterData()
        fetchInwardData()
    }, [])

    const [columnDefs] = useState([
        // Add checkbox selection column
        {
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            width: 30,
            suppressRowClickSelection: true,
        },
        {
            field: 'P_NAME',
            headerName: 'Supplier',
            menuTabs: ['filterMenuTab'],
            filter: true,
            headerClass: "headerRenoAv",
            width: 130,
            cellStyle: { textAlign: 'left' },
            cellClass: 'excelAligment',
            tooltipField: 'P_NAME',
        },
        {
            field: 'INWARD_DATETIME',
            headerName: 'Last Inward',
            menuTabs: ['filterMenuTab'],
            filter: true,
            headerClass: "headerRenoAv",
            width: 145,
            cellStyle: { textAlign: 'center' },
            cellClass: 'excelAligment',
            valueFormatter: formatDateTime,
            // tooltipField: 'INWARD_DATETIME',
        },
        {
            field: 'EXCEL_FILE_DATETIME',
            headerName: 'File Time',
            menuTabs: ['filterMenuTab'],
            filter: true,
            headerClass: "headerRenoAv",
            width: 145,
            cellStyle: { textAlign: 'center' },
            cellClass: 'excelAligment',
            valueFormatter: formatDateTime,
            // tooltipField: 'EXCEL_FILE_DATETIME',
        },
    ]);

    const toNumeric = (value) => {
        if (value === undefined || value === null || value === '') {
            return 0
        }
        const num = parseFloat(value)
        return isNaN(num) ? 0 : num
    }

    const toSmallInt = (value) => {
        if (value === undefined || value === null || value === '') {
            return 0
        }
        const num = parseInt(value, 10)
        return isNaN(num) ? 0 : num
    }



    const applyFancyColorLogic = (row) => {
        if (!row) {
            return row
        }

        const updatedRow = { ...row }

        const rawColor = updatedRow['Color']
        const colorString = rawColor !== undefined && rawColor !== null ? rawColor.toString() : ''
        const normalizedColorValue = colorString.toUpperCase().trim()

        if (normalizedColorValue === 'FANCY' || normalizedColorValue === '*') {
            updatedRow['Color'] = ''
        }

        const trimmedColor = (updatedRow['Color'] ?? '').toString().trim()
        const currentCCode = Number(updatedRow['C_CODE'] ?? 0)

        // if (trimmedColor !== '' && currentCCode === 0) {
        //     updatedRow['FancyFullName'] = trimmedColor
        //     return updatedRow
        // }
        const fancyIntensity = updatedRow['Fancy Intensity']
        const fancyOvertone = updatedRow['Fancy Overtone']
        const fancyColor = updatedRow['Fancy Color']

        const intensityValue = fancyIntensity !== undefined && fancyIntensity !== null ? fancyIntensity.toString().trim() : ''
        const overtoneValue = fancyOvertone !== undefined && fancyOvertone !== null ? fancyOvertone.toString().trim() : ''
        const fancyColorValue = fancyColor !== undefined && fancyColor !== null ? fancyColor.toString().trim() : ''
        // const hasFancyParts = [intensityValue, overtoneValue, fancyColorValue].every((value) => value !== '')

        if (currentCCode === 0) {
            if (intensityValue !== '' || overtoneValue !== '' || fancyColorValue !== '') {
                const fancyName = `${intensityValue}_${overtoneValue}_${fancyColorValue}`
                    .replace(/\s+/g, '')
                    .replace(/_/g, ' ')
                    .trim()
                updatedRow['FancyFullName'] = fancyName
            } else {
                updatedRow['FancyFullName'] = trimmedColor
            }
        }
        return updatedRow
    }

    // Get Sizecode value
    const getSizeCodeValue = (Size) => {
        const numberSize = parseFloat(Size)
        const selectedSizeCode = excelMasterData[5].find((item) => numberSize >= item.F_SIZE && numberSize <= item.T_SIZE)
        return selectedSizeCode?.SZ_Code ?? 0
    }

    // Get rap function 
    const getRapFunction = (S_CODE, Size, Q_CODE, C_CODE) => {
        let SZ_CODE = getSizeCodeValue(Size)
        let shapeCode = S_CODE;
        let qualityCode = Q_CODE;
        let colorCode = C_CODE;
        if (SZ_CODE === 19) {
            SZ_CODE = 18
        }
        if (shapeCode !== "R") {
            shapeCode = "PE"
        }
        if (shapeCode === "PE" && SZ_CODE <= 4) {
            SZ_CODE = 5;
        }
        if (colorCode >= 10 && colorCode <= 26) {
            colorCode = 10;
        }
        if (qualityCode > 11) {
            qualityCode = 11;
        }
        if (qualityCode == 0) {
            qualityCode = 1;
        }
        if (qualityCode == -1) {
            qualityCode = 1;
        }

        if (SZ_CODE !== 0) {
            const rap = excelMasterData[6].find((item) => item.SZ_CODE === SZ_CODE && item.S_CODE === shapeCode && item.C_CODE === colorCode)
            const rapCode = `Q${qualityCode}`
            return rap[rapCode] ?? 0
        }
        return 0
    }


    // Function to process other columns
    const processOtherColumns = (row) => {
        if (!row) {
            return row
        }

        const updatedRow = { ...row }

        // Process Size column: replace ".." with "."
        const sizeFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'SIZE')
        if (sizeFieldKey && updatedRow[sizeFieldKey] !== undefined && updatedRow[sizeFieldKey] !== null) {
            const sizeValue = updatedRow[sizeFieldKey].toString()
            updatedRow[sizeFieldKey] = sizeValue.replace(/\.\./g, '.')
        }

        // Process Rate column: remove $ and format to 2 decimal places
        const rateFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'RATE')
        if (rateFieldKey && updatedRow[rateFieldKey] !== undefined && updatedRow[rateFieldKey] !== null) {
            let rateValue = updatedRow[rateFieldKey].toString().trim()

            // Remove all $ symbols
            rateValue = rateValue.replace(/\$/g, '')

            // Try to parse as number
            const numericValue = parseFloat(rateValue)

            if (!isNaN(numericValue)) {
                // Format to 2 decimal places
                updatedRow[rateFieldKey] = numericValue.toFixed(2)
            } else {
                // If not a valid number, keep original value without $
                updatedRow[rateFieldKey] = 0.0
            }
        }
        // Process Discount column: remove %  and convert to decimal
        const discountFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'DIS')
        if (discountFieldKey && updatedRow[discountFieldKey] !== undefined && updatedRow[discountFieldKey] !== null) {
            let discountValue = updatedRow[discountFieldKey].toString().trim()
            discountValue = discountValue.replace(/%/g, '')

            let numericValue = parseFloat(discountValue)

            if (numericValue !== 0 && numericValue < 0) {
                numericValue *= -1
            }
            if (numericValue !== 0 && numericValue < 1) {
                numericValue *= 100
            }
            updatedRow[discountFieldKey] = numericValue
        }

        // Process Table column: remove %, °, ø, ? and convert to decimal
        const tableFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'TABLE')
        if (tableFieldKey && updatedRow[tableFieldKey] !== undefined && updatedRow[tableFieldKey] !== null) {
            let tableValue = updatedRow[tableFieldKey].toString().trim()
            // Remove %, °, ø, ? characters
            tableValue = tableValue.replace(/%/g, '').replace(/°/g, '').replace(/ø/g, '').replace(/\?/g, '')

            let numericValue = parseFloat(tableValue)

            if (!isNaN(numericValue)) {
                // If value is not 0 and less than 1, multiply by 100
                if (numericValue !== 0 && numericValue < 1) {
                    numericValue *= 100
                }
                updatedRow[tableFieldKey] = numericValue
            } else {
                updatedRow[tableFieldKey] = 0
            }
        }

        // Process Depth column: remove %, °, ø, ? and convert to decimal
        const depthFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'DEPTH')
        if (depthFieldKey && updatedRow[depthFieldKey] !== undefined && updatedRow[depthFieldKey] !== null) {
            let depthValue = updatedRow[depthFieldKey].toString().trim()
            // Remove %, °, ø, ? characters
            depthValue = depthValue.replace(/%/g, '').replace(/°/g, '').replace(/ø/g, '').replace(/\?/g, '')

            let numericValue = parseFloat(depthValue)

            if (!isNaN(numericValue)) {
                // If value is not 0 and less than 1, multiply by 100
                if (numericValue !== 0 && numericValue < 1) {
                    numericValue *= 100
                }
                updatedRow[depthFieldKey] = numericValue
            } else {
                updatedRow[depthFieldKey] = 0
            }
        }

        // Process PDepth column: remove - and convert to decimal
        const pDepthFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'PDEPTH')
        if (pDepthFieldKey && updatedRow[pDepthFieldKey] !== undefined && updatedRow[pDepthFieldKey] !== null) {
            let pDepthValue = updatedRow[pDepthFieldKey].toString().trim()
            // Remove - character
            pDepthValue = pDepthValue.replace(/-/g, '')

            let numericValue = parseFloat(pDepthValue)

            if (!isNaN(numericValue)) {
                // If value is not 0 and less than 1, multiply by 100
                if (numericValue !== 0 && numericValue < 1) {
                    numericValue *= 100
                }
                updatedRow[pDepthFieldKey] = numericValue
            } else {
                updatedRow[pDepthFieldKey] = 0
            }
        }

        // Process CDepth column: remove - and convert to decimal
        const cDepthFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'CDEPTH')
        if (cDepthFieldKey && updatedRow[cDepthFieldKey] !== undefined && updatedRow[cDepthFieldKey] !== null) {
            let cDepthValue = updatedRow[cDepthFieldKey].toString().trim()
            // Remove - character
            cDepthValue = cDepthValue.replace(/-/g, '')

            let numericValue = parseFloat(cDepthValue)

            if (!isNaN(numericValue)) {
                // If value is not 0 and less than 1, multiply by 100
                if (numericValue !== 0 && numericValue < 1) {
                    numericValue *= 100
                }
                updatedRow[cDepthFieldKey] = numericValue
            } else {
                updatedRow[cDepthFieldKey] = 0
            }
        }

        // Process CAngle column: remove °, ø, ?, - and convert to decimal
        const cAngleFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'CANGLE')
        if (cAngleFieldKey && updatedRow[cAngleFieldKey] !== undefined && updatedRow[cAngleFieldKey] !== null) {
            let cAngleValue = updatedRow[cAngleFieldKey].toString().trim()
            // Remove °, ø, ?, - characters
            cAngleValue = cAngleValue.replace(/°/g, '').replace(/ø/g, '').replace(/\?/g, '').replace(/-/g, '')

            let numericValue = parseFloat(cAngleValue)

            if (!isNaN(numericValue)) {
                // If value is not 0 and less than 1, multiply by 100
                if (numericValue !== 0 && numericValue < 1) {
                    numericValue *= 100
                }
                updatedRow[cAngleFieldKey] = numericValue
            } else {
                updatedRow[cAngleFieldKey] = 0
            }
        }

        // Process PAngle column: remove °, ø, ?, - and convert to decimal
        const pAngleFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'PANGLE')
        if (pAngleFieldKey && updatedRow[pAngleFieldKey] !== undefined && updatedRow[pAngleFieldKey] !== null) {
            let pAngleValue = updatedRow[pAngleFieldKey].toString().trim()
            // Remove °, ø, ?, - characters
            pAngleValue = pAngleValue.replace(/°/g, '').replace(/ø/g, '').replace(/\?/g, '').replace(/-/g, '')

            let numericValue = parseFloat(pAngleValue)

            if (!isNaN(numericValue)) {
                // If value is not 0 and less than 1, multiply by 100
                if (numericValue !== 0 && numericValue < 1) {
                    numericValue *= 100
                }
                updatedRow[pAngleFieldKey] = numericValue
            } else {
                updatedRow[pAngleFieldKey] = 0
            }
        }

        // Process Measurement column: trim
        const measurementFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'MEASUREMENT')
        if (measurementFieldKey && updatedRow[measurementFieldKey] !== undefined && updatedRow[measurementFieldKey] !== null) {
            updatedRow[measurementFieldKey] = updatedRow[measurementFieldKey].toString().trim()
        }

        // Process Length column: convert to numeric
        const lengthFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'LENGTH')
        if (lengthFieldKey && updatedRow[lengthFieldKey] !== undefined && updatedRow[lengthFieldKey] !== null) {
            const lengthValue = updatedRow[lengthFieldKey].toString().trim()
            // const numericValue = parseFloat(lengthValue)
            // updatedRow[lengthFieldKey] = !isNaN(numericValue) ? numericValue : 0
        }

        // Process Width column: convert to numeric
        const widthFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'WIDTH')
        if (widthFieldKey && updatedRow[widthFieldKey] !== undefined && updatedRow[widthFieldKey] !== null) {
            const widthValue = updatedRow[widthFieldKey].toString().trim()
            // const numericValue = parseFloat(widthValue)
            // updatedRow[widthFieldKey] = !isNaN(numericValue) ? numericValue : 0
        }

        // Process Height column: convert to numeric
        const heightFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'HEIGHT')
        if (heightFieldKey && updatedRow[heightFieldKey] !== undefined && updatedRow[heightFieldKey] !== null) {
            const heightValue = updatedRow[heightFieldKey].toString().trim()
            // const numericValue = parseFloat(heightValue)
            // updatedRow[heightFieldKey] = !isNaN(numericValue) ? numericValue : 0
        }

        // Process Girdle column: trim and replace "-" with " TO "
        const girdleFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'GIRDLE')
        if (girdleFieldKey && updatedRow[girdleFieldKey] !== undefined && updatedRow[girdleFieldKey] !== null) {
            let girdleValue = updatedRow[girdleFieldKey].toString().trim()
            girdleValue = girdleValue.replace(/-/g, ' TO ')
            updatedRow[girdleFieldKey] = girdleValue
        }

        // Process Certificate No column: trim and remove \r and \n
        const certNoFieldKey = Object.keys(updatedRow).find((key) => key?.toUpperCase() === 'CERTIFICATE NO')
        if (certNoFieldKey && updatedRow[certNoFieldKey] !== undefined && updatedRow[certNoFieldKey] !== null) {
            const certNoValue = updatedRow[certNoFieldKey].toString()
            if (certNoValue.trim() !== '') {
                updatedRow[certNoFieldKey] = certNoValue.trim().replace(/\r/g, '').replace(/\n/g, '')
            }
        }

        // Process Rap and Rate calculation
        let rap = 0;
        if (updatedRow['Size'] && updatedRow['S_CODE'] && updatedRow['C_CODE']) {
            if (updatedRow['Size'] !== 0 && updatedRow['S_CODE'] !== "" && updatedRow['C_CODE'] !== 0) {
                rap = getRapFunction(updatedRow['S_CODE'], updatedRow['Size'], updatedRow['Q_CODE'], updatedRow['C_CODE'])

                if (rap !== 0) {
                    updatedRow['RapPrice'] = rap?.toFixed(2);
                    updatedRow['RapAmt'] = (rap * updatedRow['Size'])?.toFixed(2);
                } else {
                    updatedRow['RapPrice'] = 0.00;
                    updatedRow['RapAmt'] = 0.00;
                }

                if (rap === 0 && updatedRow['RapPrice']) {
                    let rapPrice = updatedRow['RapPrice']?.toString().replace(/\$/g, '').trim()
                    rap = parseFloat(rapPrice).toFixed(2);
                }

                if (updatedRow['FancyFullName'] !== '' && updatedRow['C_CODE'] !== 0 && rap !== 0 && updatedRow['Rate'] === 0) {
                    const numericRate = parseFloat(updatedRow['Rate'])
                    if (!isNaN(numericRate)) {
                        updatedRow['Rate'] = rap?.toFixed(2);
                        rap = 0
                    } else {
                        updatedRow['Rate'] = 0.00;
                        rap = 0
                    }
                }

                if (rap !== 0 && updatedRow['Rate'] !== 0) {
                    const discount = 100 - ((updatedRow['Rate'] / rap) * 100)
                    updatedRow['Dis'] = discount?.toFixed(2);
                    updatedRow['Amount'] = (updatedRow['Rate'] * updatedRow['Size'])?.toFixed(2);
                }
                if (updatedRow['Dis'] !== 0 && rap !== 0 && updatedRow['Rate'] === 0) {
                    // Rap * (( 100 - Dis ) / 100 )
                    const rate = rap * ((100 - updatedRow['Dis']) / 100)
                    if (!isNaN(rate)) {
                        updatedRow['Rate'] = rate?.toFixed(2);
                    } else {
                        updatedRow['Rate'] = 0.00;
                    }
                    updatedRow['Amount'] = (updatedRow['Rate'] * updatedRow['Size'])?.toFixed(2);
                }
            }
        }

        updatedRow['Ratio'] = 0;
        const rapPrice = parseFloat(rap)?.toFixed(2);
        updatedRow['RapPrice'] = isNaN(rapPrice) ? 0.00 : rapPrice;
        updatedRow['RapAmt'] = parseFloat(rap * updatedRow['Size'])?.toFixed(2);
        updatedRow['ADD_PER'] = 0;
        const finalPer = parseFloat(updatedRow['Dis'])?.toFixed(2);
        updatedRow['FINAL_PER'] = isNaN(finalPer) ? 0.00 : finalPer;
        const finalRate = parseFloat(updatedRow['Rate'])?.toFixed(2);
        updatedRow['FINAL_RATE'] = isNaN(finalRate) ? 0.00 : finalRate;
        const finalAmount = parseFloat(updatedRow['Amount'])?.toFixed(2);
        updatedRow['FINAL_AMOUNT'] = isNaN(finalAmount) ? 0.00 : finalAmount;

        return updatedRow
    }

    useEffect(() => {
        const grid = document.querySelector('.ag-root-wrapper');
        if (grid) {
            const headerCells = grid.querySelectorAll('.ag-header-cell-label');
            headerCells.forEach(cell => {
                cell.style.textAlign = 'center';
            });
        }
    }, [inwardData]);

    const onGridReady = (params) => {
        gridApi.current = params.api;
        if (initialLoading) {
            params.api.showLoadingOverlay();
        }
    };

    // Helper function to convert string to ArrayBuffer
    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length)
        const view = new Uint8Array(buf)
        for (let i = 0; i !== s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xFF
        }
        return buf
    }

    const applyExcelMasterMappings = (row) => {
        if (!excelMasterData || excelMasterData.length === 0 || !row) {
            return row
        }

        const normalizedRow = { ...row }

        const getFieldKey = (targetNames) =>
            Object.keys(normalizedRow).find((key) => targetNames.includes(key?.trim().toUpperCase()))

        const getNamesFromMaster = (item, possibleKeys) => {
            for (const key of possibleKeys) {
                if (item?.[key]) {
                    return item[key]
                }
            }
            const fallbackKey = Object.keys(item || {}).find((key) => key?.toUpperCase().includes('NAME'))
            return fallbackKey ? item[fallbackKey] : ''
        }

        const mapFieldUsingMaster = ({
            masterIndex,
            targetFieldNames,
            masterNameKeys,
            masterCodeKey,
            outputFieldKey,
        }) => {
            const masterList = Array.isArray(excelMasterData[masterIndex]) ? excelMasterData[masterIndex] : []
            if (!masterList.length) {
                normalizedRow[outputFieldKey] = outputFieldKey === 'S_CODE' ? '' : 0
                return
            }

            const fieldKey = getFieldKey(targetFieldNames)
            const fieldValue = fieldKey ? normalizedRow[fieldKey] : null

            if (!fieldKey || fieldValue === undefined || fieldValue === null || fieldValue === '') {
                normalizedRow[outputFieldKey] = outputFieldKey === 'S_CODE' ? '' : 0
                return
            }

            const normalizedValue = String(fieldValue).trim().toUpperCase()
            if (!normalizedValue) {
                normalizedRow[outputFieldKey] = outputFieldKey === 'S_CODE' ? '' : 0
                return
            }

            const matchingEntry =
                masterList.find((item) => {
                    const names = getNamesFromMaster(item, masterNameKeys)
                        .split(',')
                        .map((name) => name.trim().toUpperCase())
                        .filter(Boolean)
                    return names.includes(normalizedValue)
                }) ||
                masterList.find((item) => {
                    const names = getNamesFromMaster(item, masterNameKeys).toUpperCase()
                    return names.includes(normalizedValue)
                })

            if (matchingEntry && matchingEntry[masterCodeKey]) {
                normalizedRow[outputFieldKey] = matchingEntry[masterCodeKey]
            } else {
                normalizedRow[outputFieldKey] = outputFieldKey === 'S_CODE' ? '' : 0
            }
        }

        mapFieldUsingMaster({
            masterIndex: 0,
            targetFieldNames: ['SHAPE'],
            masterNameKeys: ['GIA_S_NAME'],
            masterCodeKey: 'S_CODE',
            outputFieldKey: 'S_CODE',
        })

        mapFieldUsingMaster({
            masterIndex: 1,
            targetFieldNames: ['CLARITY'],
            masterNameKeys: ['GIA_Q_NAME'],
            masterCodeKey: 'Q_CODE',
            outputFieldKey: 'Q_CODE',
        })

        mapFieldUsingMaster({
            masterIndex: 2,
            targetFieldNames: ['COLOR', 'COLOUR'],
            masterNameKeys: ['GIA_C_NAME'],
            masterCodeKey: 'C_CODE',
            outputFieldKey: 'C_CODE',
        })

        const cutMasterKeys = ['GIA_CT_NAME']

        mapFieldUsingMaster({
            masterIndex: 3,
            targetFieldNames: ['CUT'],
            masterNameKeys: cutMasterKeys,
            masterCodeKey: 'CT_CODE',
            outputFieldKey: 'CT_CODE',
        })

        mapFieldUsingMaster({
            masterIndex: 3,
            targetFieldNames: ['POLISH'],
            masterNameKeys: cutMasterKeys,
            masterCodeKey: 'CT_CODE',
            outputFieldKey: 'PL_CODE',
        })

        mapFieldUsingMaster({
            masterIndex: 3,
            targetFieldNames: ['SYMMETRY', 'SYM'],
            masterNameKeys: cutMasterKeys,
            masterCodeKey: 'CT_CODE',
            outputFieldKey: 'SY_CODE',
        })

        mapFieldUsingMaster({
            masterIndex: 4,
            targetFieldNames: ['FLORO'],
            masterNameKeys: ['GIA_FL_NAME'],
            masterCodeKey: 'FL_CODE',
            outputFieldKey: 'FL_CODE',
        })

        return normalizedRow
    }

    const handleUpload = () => {
        if (!selectedStaff.P_CODE) {
            toast.error('Please select party', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            return
        }
        fileInputRef.current?.click()
    }

    const handleSaveToServer = async (processedData, uploadTime, clientFile) => {
        if (!selectedStaff.P_CODE) {
            toast.error('Please select party before saving', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
            return
        }

        if (!processedData || processedData.length === 0) {
            toast.error('No processed data available to save', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
            return
        }

        try {
            const tradingData = processedData.map((row) => ({
                StockID: row.StockID ?? '',
                ['Certificate No']: row['Certificate No'] ?? '',
                S_CODE: row.S_CODE ?? '',
                Size: toNumeric(row.Size),
                C_CODE: toSmallInt(row.C_CODE),
                Color: row.Color ?? '',
                Q_CODE: toSmallInt(row.Q_CODE),
                CT_CODE: toSmallInt(row.CT_CODE),
                PL_CODE: toSmallInt(row.PL_CODE),
                SY_CODE: toSmallInt(row.SY_CODE),
                FL_CODE: toSmallInt(row.FL_CODE),
                Lab: row.Lab ?? '',
                RapPrice: toNumeric(row.RapPrice),
                Dis: toNumeric(row.Dis),
                Rate: toNumeric(row.Rate),
                Amount: toNumeric(row.Amount),
                ADD_PER: toNumeric(row.ADD_PER),
                FINAL_PER: toNumeric(row.FINAL_PER),
                FINAL_RATE: toNumeric(row.FINAL_RATE),
                FINAL_AMOUNT: toNumeric(row.FINAL_AMOUNT),
                Measurement: row.Measurement ?? '',
                Table: toNumeric(row.Table),
                Depth: toNumeric(row.Depth),
                Ratio: toNumeric(row.Ratio),
                Status: row.Status ?? '',
                Comment: row.Comment ?? '',
                ['Video URL']: row['Video URL'] ?? '',
                ['Image URL']: row['Image URL'] ?? '',
                ['Cert URL']: row['Cert URL'] ?? '',
                Girdle: row.Girdle ?? '',
                Culet: row.Culet ?? '',
                CAngle: toNumeric(row.CAngle),
                CHeight: toNumeric(row.CHeight),
                PAngle: toNumeric(row.PAngle),
                PDepth: toNumeric(row.PDepth),
                ['Fancy Intensity']: row['Fancy Intensity'] ?? '',
                ['Fancy Overtone']: row['Fancy Overtone'] ?? '',
                ['Fancy Color']: row['Fancy Color'] ?? '',
                Location: row.Location ?? '',
                Length: row.Length ?? '',
                Width: row.Width ?? '',
                Height: row.Height ?? '',
                FancyFullName: row.FancyFullName ?? '',
                GirdleThin: row.GirdleThin ?? '',
                GirdleThick: row.GirdleThick ?? '',
                Shape: row.Shape ?? '',
                Clarity: row.Clarity ?? '',
            }))

            const body = {
                P_CODE: selectedStaff.P_CODE,
                EXCEL_FILE_TIME: uploadTime || new Date().toISOString(),
                TRADINGDATA: tradingData,
            }

            const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/uploadExcelData`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })

            const result = await response.json()
            const message = result.message

            // Check if message is an array and generate Excel file
            if (Array.isArray(message) && message.length > 0) {
                try {
                    // Get all unique field names (headers) from the array
                    const allHeaders = new Set()
                    message.forEach(row => {
                        if (row && typeof row === 'object') {
                            Object.keys(row).forEach(key => allHeaders.add(key))
                        }
                    })
                    const headers = Array.from(allHeaders)

                    // Create Excel data array with headers
                    const excelData = [headers]

                    // Add data rows
                    message.forEach(row => {
                        if (row && typeof row === 'object') {
                            const rowData = headers.map(header => (row[header] ?? ''))
                            excelData.push(rowData)
                        }
                    })

                    // Create a new workbook
                    const ws = XLSX.utils.aoa_to_sheet(excelData)
                    const wb = XLSX.utils.book_new()
                    XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1')

                    // Convert the workbook to a binary string
                    const wbBinary = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

                    // Create a Blob from the binary string
                    const blob = new Blob([s2ab(wbBinary)], { type: 'application/octet-stream' })

                    // Generate filename with selected staff name
                    const filename = `Not Inward List.xlsx`

                    // Create a download link and trigger the download
                    const downloadLink = document.createElement('a')
                    downloadLink.href = URL.createObjectURL(blob)
                    downloadLink.download = filename
                    document.body.appendChild(downloadLink)
                    downloadLink.click()
                    document.body.removeChild(downloadLink)
                    URL.revokeObjectURL(downloadLink.href)
                } catch (excelError) {
                    console.error('Error generating Excel file:', excelError)
                }
            }

            if (result.success) {
                // Upload original Excel file to Azure cloud
                try {
                    // Generate directory structure: month/day/filename
                    const currentDate = new Date()
                    const month = currentDate.getMonth() + 1 // getMonth() returns 0-11, so add 1
                    const day = currentDate.getDate()

                    const fileExtension = clientFile.name.split('.').pop()
                    const blobName = `${selectedStaff.P_CODE} - ${selectedStaff.P_NAME}.${fileExtension}`
                    const directoryName = `${month}/${day}`

                    const uploadResult = await uploadExcelToAzure({
                        excelFile: clientFile,
                        blobName: blobName,
                        directoryName: directoryName
                    })

                    if (uploadResult.success) {
                        console.log('Excel file uploaded to Azure successfully:', uploadResult.url)
                    } else {
                        toast.error(uploadResult.error || 'Failed to upload Excel file to Azure', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        })
                    }
                } catch (uploadError) {
                    console.error('Error uploading Excel file to Azure:', uploadError)
                }
            }

            if (response.ok && result.success) {
                toast.success('Uploaded successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                })
                // Refresh inward data after successful upload
                await fetchInwardData()
            } else {
                toast.error(result.message || 'Failed to save Excel data', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                })
            }
            setIsLoading(false)
        } catch (error) {
            console.error('Error saving Excel data:', error)
            toast.error('Error saving Excel data', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
        }
    }

    const handleFileChange = async (event) => {
        const selectedFile = event.target.files[0]
        if (!selectedFile) {
            return
        }
        setIsLoading(true)

        const date = new Date(selectedFile.lastModified);
        const istOffset = 5.5 * 60 * 60 * 1000; // +5:30

        const istDate = new Date(date.getTime() + istOffset);

        const uploadTime = istDate.toISOString();

        // Capture the Excel file's last modified time
        try {
            // First, get the field mapping data from API
            const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/partyFieldsMap`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    P_CODE: selectedStaff.P_CODE
                })
            })
            const data = await response.json()
            const fieldMapData = data.data

            // Check if file is CSV or Excel
            const fileExtension = selectedFile.name.split('.').pop().toLowerCase()
            const isCSV = fileExtension === 'csv'

            // Read file and process data
            const reader = new FileReader()
            reader.onload = async (e) => {
                try {
                    let sheetData = []
                    let headers = []
                    let worksheet = null

                    if (isCSV) {
                        // Parse CSV file using papaparse
                        const csvText = e.target.result
                        const parseResult = Papa.parse(csvText, {
                            header: false,
                            skipEmptyLines: true,
                            encoding: 'UTF-8'
                        })

                        if (parseResult.errors.length > 0) {
                            console.warn('CSV parsing warnings:', parseResult.errors)
                        }

                        sheetData = parseResult.data
                    } else {
                        // Parse Excel file using XLSX
                        const fileData = new Uint8Array(e.target.result)
                        const workbook = XLSX.read(fileData, { type: 'array' })

                        const firstSheetName = workbook.SheetNames[0]
                        worksheet = workbook.Sheets[firstSheetName]

                        // Get data as array of arrays (header: 1 means first row is headers)
                        sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: false })
                    }

                    if (sheetData.length > 0) {
                        // Get SKIP_ROWS value from selectedStaff, default to 0 if not available
                        const skipRowsValue = selectedStaff.SKIP_ROWS ? parseInt(selectedStaff.SKIP_ROWS, 10) : 0
                        const skipRows = isNaN(skipRowsValue) ? 0 : Math.max(0, skipRowsValue) // Ensure it's a valid non-negative number

                        // Skip the specified number of rows
                        const dataAfterSkip = skipRows > 0 ? sheetData.slice(skipRows) : sheetData

                        if (dataAfterSkip.length === 0) {
                            toast.error('No data found after skipping rows. Please check SKIP_ROWS value.', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "dark",
                            })
                            return
                        }

                        // First row after skip contains the headers
                        const headers = dataAfterSkip[0].filter(header => header !== undefined && header !== null && header !== '')
                        // Check if URL extraction is enabled
                        const isUrlExtract = selectedStaff.IS_URL_EXTRACT === "TRUE" || selectedStaff.IS_URL_EXTRACT === true

                        // Create mapping object: MapField -> Field (only for IS_MAP === "YES")
                        const fieldMapping = {}
                        // Track which fields should have hyperlinks extracted (IS_MAP === "YES" AND IS_URL_EXTRACT === "TRUE")
                        const fieldsToExtractHyperlinks = {}
                        if (fieldMapData && Array.isArray(fieldMapData)) {
                            fieldMapData.forEach(mapItem => {
                                if (mapItem.MapField && mapItem.Field) {
                                    // For every mapping, create object: { "Name": Field, is_ui_mapped: Boolean }
                                    // Capitalize only the first letter for the key, rest lower (for "Name")
                                    const formattedKey = mapItem.MapField.toUpperCase();
                                    fieldMapping[formattedKey] = {
                                        Field: mapItem.Field,
                                        is_ui_mapped: false
                                    };
                                    // Track that this field should have hyperlink extracted only if IS_URL_EXTRACT is TRUE and IS_MAP is "YES"
                                    if (mapItem.IS_MAP === "YES" && isUrlExtract) {
                                        fieldsToExtractHyperlinks[formattedKey] = mapItem.Field
                                    }
                                }
                            })
                        }

                        // Process Excel data rows (skip header row) and extract hyperlinks per row
                        const dataRows = dataAfterSkip.slice(1)

                        // Keep only rows that have at least one non-empty cell
                        const nonEmptyDataRows = dataRows.filter((row) =>
                            Array.isArray(row) &&
                            row.some((cell) => cell !== undefined && cell !== null && String(cell).trim() !== '')
                        )


                        const processedData = nonEmptyDataRows.map((row, rowIndex) => {
                            const processedRow = {}

                            // Reset is_ui_mapped flag for all fields at the start of each row
                            Object.keys(fieldMapping).forEach(key => {
                                fieldMapping[key].is_ui_mapped = false
                            })

                            // Map each column value to standard field name and extract hyperlinks
                            headers.forEach((header, colIndex) => {
                                const standerdField = fieldMapping[header?.trim().toUpperCase()]
                                const standardFieldName = fieldMapping[header?.trim().toUpperCase()]?.Field || header
                                const cellValue = row[colIndex] !== undefined ? row[colIndex] : ''

                                if (standerdField?.is_ui_mapped) {
                                    return
                                }
                                // Only extract hyperlink if this field has IS_MAP === "YES" and it's an Excel file
                                if (fieldsToExtractHyperlinks[header?.trim().toUpperCase()] && !isCSV && worksheet) {
                                    // Extract hyperlink for this specific cell (Excel only)
                                    // Account for skipped rows: rowIndex + 1 (for header) + skipRows
                                    const actualRowIndex = rowIndex + 1 + skipRows
                                    const cellAddress = XLSX.utils.encode_cell({ r: actualRowIndex, c: colIndex })
                                    const cell = worksheet[cellAddress]

                                    try {
                                        let hyperlink = null

                                        if (cell && cell.l && cell.l.Target) {
                                            hyperlink = cell.l.Target
                                        } else if (cell && cell.l && cell.l.display) {
                                            // Extract hyperlink from display text
                                            const match = /http?:\/\/[^\s)]+/i.exec(cell.l.display)
                                            if (match && match[0]) {
                                                hyperlink = match[0]
                                            }
                                        } else if (cell && cell.f) {
                                            // Extract hyperlink from formula
                                            const formulaMatch = /"([^"]+\.com[^"]*)"/.exec(cell.f)
                                            if (formulaMatch && formulaMatch[1]) {
                                                hyperlink = formulaMatch[1]
                                            }
                                        }

                                        // If hyperlink found, use it as the value; otherwise use cell value
                                        const finalStandardFieldName = fieldsToExtractHyperlinks[header?.trim().toUpperCase()];
                                        processedRow[finalStandardFieldName] = hyperlink || cellValue;
                                        if (fieldMapping[header?.trim().toUpperCase()]) {
                                            fieldMapping[header?.trim().toUpperCase()].is_ui_mapped = true
                                        }
                                    } catch (error) {
                                        console.error('Error extracting hyperlink:', error)
                                        // If error, use cell value
                                        processedRow[standardFieldName] = cellValue
                                    }
                                } else {
                                    // For CSV files or fields without IS_MAP === "YES", just store the cell value
                                    processedRow[standardFieldName] = cellValue
                                    if (fieldMapping[header?.trim().toUpperCase()]) {
                                        fieldMapping[header?.trim().toUpperCase()].is_ui_mapped = true
                                    }
                                }
                            })

                            return processOtherColumns(applyFancyColorLogic(applyExcelMasterMappings(processedRow)))
                        })

                        // Also extract hyperlinks from worksheet.Hyperlinks object (only for Excel files, IS_MAP === "YES" fields and IS_URL_EXTRACT === "TRUE")
                        const columnHyperlinkData = {}
                        if (!isCSV && isUrlExtract && worksheet && worksheet.Hyperlinks) {
                            worksheet.Hyperlinks.forEach(hyperlink => {
                                const [row, col] = XLSX.utils.decode_range(hyperlink.cell)
                                // Check if this hyperlink is after the skipped rows
                                if (row >= skipRows && col < headers.length) {
                                    const columnName = headers[col]

                                    // Only extract if this field has IS_MAP === "YES" and IS_URL_EXTRACT is enabled
                                    if (columnName && fieldsToExtractHyperlinks[columnName]) {
                                        const standardFieldName = fieldsToExtractHyperlinks[columnName]
                                        columnHyperlinkData[standardFieldName] = hyperlink.address
                                    }
                                }
                            })
                        }

                        await handleSaveToServer(processedData, uploadTime, selectedFile)
                    }
                } catch (error) {
                    console.error('Error reading file:', error)
                    toast.error('Error reading file. Please make sure it is a valid Excel or CSV file.', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    })
                }
            }

            reader.onerror = () => {
                console.error('Error reading file')
                toast.error('Error reading file', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                })
            }

            // Read file as text for CSV, as ArrayBuffer for Excel
            if (isCSV) {
                reader.readAsText(selectedFile, 'UTF-8')
            } else {
                reader.readAsArrayBuffer(selectedFile)
            }

            event.target.value = ''
        } catch (error) {
            console.error('Error reading Excel file:', error)
            toast.error('Error reading Excel file. Please make sure it is a valid Excel file.', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
        }
    }

    const onSelectionChanged = () => {
        const selectedRows = gridApi.current.getSelectedRows()
        setSelectedRows(selectedRows)
    }
    const handleUpdateInwardDataTime = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/updateInwardDataTime`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    P_CODE: selectedRows[0].P_CODE,
                    USERNAME: localStorage.getItem('USERNAME'),
                    PASSWORD: localStorage.getItem('PASSWORD')
                })
            })
            const result = await response.json()
            if (result.success) {
                await fetchInwardData()
                toast.success('Inward Date Update Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                })
            } else {
                toast.error('Failed to update inward date', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                })
            }
        } catch (error) {
            console.error('Error updating inward date:', error)
            toast.error('Error updating inward date', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
        }
    }
    const [isOpen, setIsOpen] = useState(false)
    const navigate = useNavigate()
    const handleLogOut = async () => {
        // await removeFcmToken()
        localStorage.removeItem('USERNAME')
        localStorage.removeItem('PASSWORD')
        localStorage.removeItem('IS_HOLD')
        localStorage.removeItem('IS_CONFIRM')
        localStorage.removeItem('IS_CLIENT_PRICE')
        localStorage.removeItem('IS_VENDOR')
        localStorage.removeItem('IS_STAFF')
        localStorage.removeItem('IS_RECEIVE')
        localStorage.removeItem('IS_EXCEL_INWARD')
        localStorage.removeItem('IS_VENDOR_NAME')
        localStorage.removeItem('IS_CLIENT_WEB')
        localStorage.removeItem('IS_SHOW_HOLD_BUTTON')
        localStorage.removeItem('IS_PRICE_EXCEL')
        localStorage.removeItem('IS_HOLD_INQURY')
        navigate('/')
    };

    function openModal() {
        setIsOpen(true);
    }
    function closeModal() {
        setIsOpen(false);
    }
    const [notUpdatedListLoader, setNotUpdatedListLoader] = useState(false)
    const [isNotUpdatedModalOpen, setIsNotUpdatedModalOpen] = useState(false)
    const [notUpdatedListData, setNotUpdatedListData] = useState([])
    const notUpdatedGridRef = useRef(null)
    const notUpdatedGridApi = useRef(null)

    const handleNotUpdatedListClick = async () => {
        try {
            setNotUpdatedListLoader(true)
            const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/notUpdatedList`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    USERNAME: localStorage.getItem('USERNAME'),
                    PASSWORD: localStorage.getItem('PASSWORD')
                })
            })
            const data = await response.json()
            if (data.success && data.message) {
                setNotUpdatedListData(data.message)
                setIsNotUpdatedModalOpen(true)
            } else {
                toast.error(data.message || 'Failed to fetch not updated list', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                })
            }
        } catch (error) {
            console.error('Error fetching not updated list:', error)
            toast.error('Error fetching not updated list', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
        } finally {
            setNotUpdatedListLoader(false)
        }
    }

    const closeNotUpdatedModal = () => {
        setIsNotUpdatedModalOpen(false)
        setNotUpdatedListData([])
    }

    const onNotUpdatedGridReady = (params) => {
        notUpdatedGridApi.current = params.api
    }

    // Generate column definitions dynamically from the data
    const notUpdatedColumnDefs = useMemo(() => {
        if (!notUpdatedListData || notUpdatedListData.length === 0) {
            return []
        }
        return [
            {
                field: 'Name',
                headerName: 'Name',
                menuTabs: ['filterMenuTab'],
                filter: true,
                headerClass: "headerRenoAv",
                width: 135,
                cellStyle: { textAlign: 'left' },
                cellClass: 'excelAligment',
                tooltipField: 'Name',
            },
            {
                field: 'STOCK_TYPE',
                headerName: 'Type',
                menuTabs: ['filterMenuTab'],
                filter: true,
                headerClass: "headerRenoAv",
                width: 85,
                cellStyle: {
                    textAlign: 'center',
                    // cursor: 'pointer',
                    // textDecoration: 'underline',
                },
                cellClass: 'excelAligment',
                // tooltipField: 'STOCK_TYPE',
                // onCellClicked: (params) => {
                //     // Adjust the field name below ('Link') to whatever field
                //     // in your API response contains the URL
                //     let url = params.data?.WA_LINK || params.value
                //     if (!url) {
                //         toast.error('No link available for this row', {
                //             position: "top-right",
                //             autoClose: 3000,
                //             hideProgressBar: false,
                //             closeOnClick: true,
                //             pauseOnHover: true,
                //             draggable: true,
                //             progress: undefined,
                //             theme: "dark",
                //         })
                //         return
                //     }

                //     // Ensure URL has protocol
                //     if (!/^https?:\/\//i.test(url)) {
                //         url = `${url}`
                //     }
                //     window.open(url, '_blank', 'noreferrer')
                // },
            },
            {
                field: 'LastImport',
                headerName: 'Last Import',
                menuTabs: ['filterMenuTab'],
                filter: true,
                headerClass: "headerRenoAv",
                width: 180,
                cellStyle: { textAlign: 'left' },
                cellClass: 'excelAligment',
                // tooltipField: 'LastImport',
            }
        ]
    }, [notUpdatedListData])
    return (
        <>
            <ToastContainer />
            <div>
                {isLoading && (
                    <div className='flex justify-center items-center h-screen'>
                        <span className="loader" style={{
                            border: "5px solid #111",
                            borderBottomColor: "transparent",
                            borderRadius: "50%",
                            width: "48px",
                            height: "48px",
                            display: "inline-block",
                            boxSizing: "border-box",
                            animation: "rotation 1s linear infinite"
                        }}></span>
                        {/* Add keyframes in a style tag to ensure loader spin */}
                        <style>
                            {`
                            @keyframes rotation {
                              0% { transform: rotate(0deg); }
                              100% { transform: rotate(360deg); }
                            }
                        `}
                        </style>
                    </div>
                )}
                <div className='flex flex-col md:flex-row gap-2 items-center'>
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        accept=".xlsx,.xls,.csv"
                    />
                    <div className='flex gap-2 p-3 items-center'>
                        <h1 className='text-lg font-medium'>Party:</h1>
                        <div>
                            <select className={`w-[180px] relative border border-black bg-gray-200 rounded-lg p-1 `} onChange={(e) => setSelectedStaff(JSON.parse(e.target.value))} value={JSON.stringify(selectedStaff)}>
                                <option value='' className='bg-gray-200 w-[120%]' selected >Select</option>
                                {staffData?.map((item) => (
                                    <option key={item.P_CODE} value={JSON.stringify(item)} selected={selectedStaff.P_CODE === item.P_CODE}>{item.P_NAME}</option>
                                ))}
                            </select>
                        </div>
                        <button className='bg-green-500 text-white px-4 py-[6px] rounded-lg' onClick={handleUpload}>Upload</button>
                    </div>
                    <div className='flex gap-2 items-center w-full'>
                        <div className='w-[90%] md:w-full flex pl-2 justify-between gap-2'>
                            <button className={`${selectedRows.length > 0 ? 'bg-blue-500' : 'bg-gray-500'} text-white w-[full] px-2 md:px-4 py-[6px] rounded-lg ${selectedRows.length > 0 ? 'cursor-pointer' : 'cursor-not-allowed'}`} onClick={handleUpdateInwardDataTime} disabled={selectedRows.length === 0}>Inward Date Update</button>
                            <button
                                className={`${notUpdatedListLoader ? 'bg-orange-300' : 'bg-orange-500'} text-white w-[full] px-2 md:px-4 py-[6px] rounded-lg ${notUpdatedListLoader ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                onClick={handleNotUpdatedListClick}
                                disabled={notUpdatedListLoader}
                            >
                                Not Updated List
                            </button>
                        </div>
                        <div className='button-logout !w-[10%] md:!w-[110px] flex justify-end mr-2'>
                            <button class="logout-hover hidden md:block" onClick={openModal}>
                                Log Out
                            </button>
                            <button class="logout-hover md:hidden flex justify-center items-center" onClick={openModal}>
                                <IoLogOut className='text-2xl' />
                            </button>
                        </div>
                    </div>
                </div>
                <div id="gridTable" style={gridStyle} className="ag-theme-alpine !mt-5">
                    <AgGridReact
                        rowData={inwardData}
                        columnDefs={columnDefs}
                        ref={gridRef}
                        onGridReady={onGridReady}
                        rowSelection='single'
                        suppressRowClickSelection={true}
                        onSelectionChanged={onSelectionChanged}
                        overlayLoadingTemplate='<div class="ag-overlay-loading-center">Loading...</div>'
                        overlayNoRowsTemplate='<div class="ag-overlay-loading-center">No data to show</div>'
                    ></AgGridReact>
                </div>
            </div>
            <Modal open={isOpen} footer={null} width={305} closable={false} onCancel={closeModal} centered>
                <label style={{ width: "100%", textAlign: "center", marginLeft: "44px" }}>Are you sure want to Logout?</label>
                <div style={{ display: "flex", justifyContent: "center", gap: "15px", marginTop: "10px" }}>
                    <button className='hold-hover' onClick={handleLogOut}>
                        Yes
                    </button>
                    <button className='confirm-hover' onClick={closeModal}>
                        No
                    </button>
                </div>
            </Modal>
            <Modal
                open={isNotUpdatedModalOpen}
                footer={null}
                width="95%"
                style={{ maxWidth: '410px' }}
                onCancel={closeNotUpdatedModal}
                centered
                title={
                    <div className='flex justify-center items-center'>
                        <span className='text-lg font-medium pt-2'>Not Updated List</span>
                    </div>
                }
            >
                {notUpdatedListLoader ? (
                    <div className='flex justify-center items-center' style={{ minHeight: '200px' }}>
                        <span className="loader" style={{
                            border: "5px solid #111",
                            borderBottomColor: "transparent",
                            borderRadius: "50%",
                            width: "48px",
                            height: "48px",
                            display: "inline-block",
                            boxSizing: "border-box",
                            animation: "rotation 1s linear infinite"
                        }}></span>
                    </div>
                ) : (
                    <div style={{ height: '75vh', width: '100%' }} className="ag-theme-alpine !mt-2">
                        <AgGridReact
                            rowData={notUpdatedListData}
                            columnDefs={notUpdatedColumnDefs}
                            ref={notUpdatedGridRef}
                            onGridReady={onNotUpdatedGridReady}
                            defaultColDef={{
                                resizable: true,
                                sortable: true,
                                filter: true,
                            }}
                            getRowStyle={(params) => {
                                const dayDiff = params.data?.DayDiff?.toLowerCase();
                                if (dayDiff === 'one') {
                                    return {
                                        color: '#000',
                                        backgroundColor: '#ffb547',
                                    };
                                } else {
                                    return {
                                        color: '#fff',
                                        backgroundColor: '#ff3b3b'
                                    };
                                }
                            }}
                            overlayNoRowsTemplate='<div class="ag-overlay-loading-center">No data to show</div>'
                        />
                    </div>
                )}
            </Modal>
        </>
    )
}

export default Inward
